/**
 * Define a column to be displayed in a TableModel.
 * The 'title' is used in the column header, the 'field' defines which field of the table data models is being
 * displayed in the column.
 */
export class ColumnModel {
    public constructor(
        public title: string,
        public field: string,
    ) {}
}
